import styled from 'styled-components';

const PhoneLayout = styled.div `
  width: 380px;
  margin: 0 auto;
  .login-btn {
    width: 100%;
    height: 44px;
    font-size: var(--font-size-lg);
  }
`;

export { PhoneLayout };
